// extracted by mini-css-extract-plugin
export var aircallIframe = "_h1-3";
export var fabContainer = "_h1-5";
export var fabRinging = "_h1-6";
export var loadingOverlay = "_h1-4";
export var pulse = "_h1-7";
export var widgetContent = "_h1-2";
export var widgetPanel = "_h1-0";
export var widgetPanelExpanded = "_h1-1";